// src/pages/PrivacyPolicy.tsx
import React, { useContext } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { RuntimeValuesContext } from '../context/RuntimeValuesContext';
import PrivacyPolicyEN from './PrivacyPolicyEN';
import PrivacyPolicyES from './PrivacyPolicyES';
import { Helmet } from 'react-helmet';
import '../styles/Styles.css';

function PrivacyPolicy() {
    const { runtimeValues } = useContext(RuntimeValuesContext);

    const title = runtimeValues.language === 'ESPAÑOL'
        ? "Política de Privacidad - wicaglobalgear.com"
        : "Privacy Policy - wicaglobalgear.com";

    return (
        <>
            <Helmet><title>{title}</title></Helmet>
            <div className="app-container">
                <Header />
                <div className="app-content">
                    <section className="sectionPageContent">
                        {runtimeValues.language === 'ESPAÑOL' ? <PrivacyPolicyES /> : <PrivacyPolicyEN />}
                    </section>
                </div>
                <Footer />
            </div>
        </>
    );
}

export default PrivacyPolicy;